import { Outlet } from 'react-router-dom'
import BackgroundImage from './components/BackgroundImage'
import * as Styles from './PublicLayout.styles'

const PublicSignupLayout = () => {
  return (
    <Styles.Container>
      <div className="py-12 px-4 flex flex-col md:justify-center lg:items-center relative">
        <Styles.Logo src="/images/logo.png" alt="SureFire" />
        <Styles.Header>
          <Styles.MobileLogo src="/images/mobile-logo.png" alt="SureFire" />
        </Styles.Header>
        <Styles.Content>
          <Outlet />
        </Styles.Content>
      </div>
      <div className="py-12 px-4 hidden md:flex flex-col md:justify-center lg:items-center relative">
        <BackgroundImage src="/images/signup.png" alt="Signup" />
      </div>
    </Styles.Container>
  )
}
export default PublicSignupLayout
